import { render, staticRenderFns } from "./InformacionConfig.vue?vue&type=template&id=14e920a0&scoped=true"
import script from "./InformacionConfig.vue?vue&type=script&lang=js"
export * from "./InformacionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e920a0",
  null
  
)

export default component.exports